module.exports = __webpack_public_path__ + "static/img/card-contact-website.804173a5.png";